import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../../utils/metaPixel';

/**
 * El PageView de la primera carga lo registra initMetaPixel().
 * Este componente solo registra los cambios de página dentro del sitio,
 * para no contar la misma visita dos veces.
 */
export function MetaPixelRouteTracker() {
  const {
    pathname
  } = useLocation();
  const isFirst = useRef(true);
  useEffect(() => {
    if (isFirst.current) {
      isFirst.current = false;
      return;
    }
    trackPageView();
  }, [pathname]);
  return null;
}